// tobe AI 앱의 타이포그래피 시스템
export const typography = {
    fontFamily: "'SUIT', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",

    // Heading Styles
    h1: {
        fontFamily: "'SUIT', sans-serif",
        fontSize: '24px',
        fontWeight: 700,
        color: '#171719',
        lineHeight: 1.33,
        letterSpacing: '-0.20px',
    },

    h2: {
        fontFamily: "'SUIT', sans-serif",
        fontSize: '20px',
        fontWeight: 700,
        color: '#171719',
        lineHeight: 1.33,
        letterSpacing: '-0.20px',
    },

    h3: {
        fontFamily: "'SUIT', sans-serif",
        fontSize: '18px',
        fontWeight: 700,
        color: '#171719',
        lineHeight: 1.33,
        letterSpacing: '-0.20px',
    },

    h4: {
        fontFamily: "'SUIT', sans-serif",
        fontSize: '17px',
        fontWeight: 700,
        color: '#171719',
        lineHeight: 1.41,
        letterSpacing: '-0.20px',
    },

    // Body Styles
    body1: {
        fontFamily: "'SUIT', sans-serif",
        fontSize: '16px',
        fontWeight: 400,
        color: '#171719',
        lineHeight: 1.5,
        letterSpacing: '-0.16px',
    },

    body2: {
        fontFamily: "'SUIT', sans-serif",
        fontSize: '14px',
        fontWeight: 400,
        color: '#171719',
        lineHeight: 1.43,
        letterSpacing: '-0.14px',
    },

    // Caption Styles
    caption: {
        fontFamily: "'SUIT', sans-serif",
        fontSize: '12px',
        fontWeight: 400,
        color: '#70737C',
        lineHeight: 1.33,
        letterSpacing: '-0.12px',
    },

    // Button Styles
    button: {
        fontFamily: "'SUIT', sans-serif",
        fontSize: '16px',
        fontWeight: 600,
        letterSpacing: '-0.16px',
    },

    // Hero Styles (랜딩 페이지용)
    hero: {
        fontFamily: "'SUIT', sans-serif",
        fontSize: '48px',
        fontWeight: 700,
        color: '#171719',
        lineHeight: 1.2,
        letterSpacing: '-0.48px',
    },

    subtitle: {
        fontFamily: "'SUIT', sans-serif",
        fontSize: '20px',
        fontWeight: 400,
        color: '#70737C',
        lineHeight: 1.4,
        letterSpacing: '-0.20px',
    },
} as const;

export type TypographyKey = keyof typeof typography; 